import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import Loading from 'layoutComponents/Loading';
import RaisedButton from 'material-ui/RaisedButton';
import ActionSearch from 'material-ui/svg-icons/action/search';
import EquipmentSearchResults from 'equipmentComponents/EquipmentSearchResults';

class EquipmentSearch extends React.Component {

    constructor(props) {
        super(props);

        this.onSearchValueChange = this
            .onSearchValueChange
            .bind(this);
        this.onSearchStartClick = this
            .onSearchStartClick
            .bind(this);

    }

    onSearchValueChange(e) {
        const {techInventoryActions} = this.props;
        techInventoryActions.setSearchValue(e.target.value);
    }

    onSearchStartClick() {
        const {techInventoryActions, inventorySearch} = this.props;

        techInventoryActions.searchInventoryStarted({
            search: inventorySearch.get('searchValue')
        });
    }

    render() {
        const {inventorySearch} = this.props;
        let currentValue = '',
            error = null,
            loading = null,
            results = null;
        if (inventorySearch) {
            currentValue = inventorySearch.get('searchValue');

            if (inventorySearch.get('error')) {
                error = (
                    <div className="card-panel red">
                        <span className="white-text text-darken-2">{inventorySearch.get('error')}</span>
                    </div>
                );
            }

            loading = (<Loading
                message="Searching for Equipment..."
                isLoading={inventorySearch.get('loading') || false}/>);

        }

        if (inventorySearch && inventorySearch.get('details')) {
            results = inventorySearch.get('details');
        }

        return (
            <div>
                <TextField
                    fullWidth
                    onChange={this.onSearchValueChange}
                    defaultValue={currentValue ? currentValue : null}
                    floatingLabelText="Enter serial number or mac address"/>

                <RaisedButton
                    label="Search"
                    style={{
                    marginTop: '20px'
                }}
                    onTouchTap={this.onSearchStartClick}
                    primary={true}
                    disabled={!currentValue}
                    icon={< ActionSearch />}/> {error}{loading}

                <EquipmentSearchResults searchResults={results}/>
            </div>
        );
    }
}

EquipmentSearch.propTypes = {
    techInventoryActions: PropTypes.object,
    inventorySearch: PropTypes.object

};

export default EquipmentSearch;



// WEBPACK FOOTER //
// ./src/components/equipment/EquipmentSearch.js